import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Form, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import './RoutingGuide.scss';

const RoutingGuide = () => {
  const location = useLocation();
  const [providerTypes, setProviderTypes] = useState([]);
  const [selectedProviderType, setSelectedProviderType] = useState(new URLSearchParams(location.search).get('providerType') || '');
  const navigate = useNavigate();

  const fetchProviderTypes = useCallback(async () => {
    try {
      const response = await axios.get('/api/provider_types');
      setProviderTypes(response.data);
    } catch (error) {
      console.error('Error fetching provider types:', error);
    }
  }, []);

  useEffect(() => {
    fetchProviderTypes();
  }, [fetchProviderTypes]);

  const handleProviderTypeChange = (e) => {
    setSelectedProviderType(e.target.value);
  };

  const handleGo = () => {
    navigate(`/routing-guide/list?providerType=${selectedProviderType}`);
  };

  return (
    <div className="routing-guide">
      <h1>Routing Guide Page</h1>
      <p className="note">
        This is your routing guide management interface. Here you will define, per modality, which provider will be selected when a user searches for a specific route. It gives you full control over the allocation of tradelanes to partners, or your own schedule.
      </p>
      <Form.Group controlId="providerType" className="provider-type-dropdown">
        <Form.Label>Select a modality</Form.Label>
        <Form.Control as="select" value={selectedProviderType} onChange={handleProviderTypeChange}>
          <option value="">Please select a modality to begin...</option>
          {providerTypes.map((type) => (
            <option key={type.provider_type_id} value={type.provider_type_name}>
              {type.provider_type_name} ({type.provider_type_long_name})
            </option>
          ))}
        </Form.Control>
        <Button onClick={handleGo} className="ml-2">Go</Button>
      </Form.Group>
    </div>
  );
};

export default RoutingGuide;
